/* eslint-disable @next/next/no-img-element */
import { useState } from 'react';
import { BoxWithOptionalNumberedHeading } from './BoxWithNumberedHeading';

import { useDrawStore } from 'hooks/stores/useDrawStore';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import { ASSET_PREFIX } from 'utils/constants';
import { EntryMethodDetails } from '../EntryMethod';
import NewSelectEntriesSection from '../NewSelectEntriesSection';
import YourNumbersPopup from '../YourNumbersPopup';

interface IChooseNumbers {}

export const ChooseNumbers = observer(({}: IChooseNumbers) => {
  const { numberSetup } = useDrawStore();
  const {
    entryMethod,
    lines,
    setLines,
    setLineNumber,
    setLineBonusNumber,
    removeLine,
    generateLineRandomNumbers,
  } = useEnterStore();

  const [showChooseNumbersPopup, setShowChooseNumbersPopup] =
    useState<boolean>(false);

  if (!numberSetup) {
    return null;
  }
  return (
    <BoxWithOptionalNumberedHeading
      additionalClassName={'!border-2'}
      onClickInfoIcon={() => setShowChooseNumbersPopup(true)}
      number={undefined}
    >
      {showChooseNumbersPopup && (
        <YourNumbersPopup
          onClose={() => setShowChooseNumbersPopup(false)}
          entryMethod={entryMethod}
        />
      )}
      <p
        style={{ fontSize: 20 }}
        className=" normal-case spacing-normal tracking-normal font-extrabold text-center w-full"
      >
        Your Lucky Numbers
        <img
          src={`${ASSET_PREFIX}/images/info-circle.svg`}
          className="hover:pointer-cursor h-5 ml-2 pt-1"
          onClick={() => setShowChooseNumbersPopup(true)}
          alt="more info"
        />
      </p>
      <div className="grid gap-2em -mt-6">
        <NewSelectEntriesSection
          lines={lines}
          setLines={setLines}
          setLineNumber={setLineNumber}
          setLineBonusNumber={setLineBonusNumber}
          removeLine={removeLine}
          generateLineRandomNumbers={generateLineRandomNumbers}
          glowColor={EntryMethodDetails[entryMethod]?.underlineGlowColor}
          noBorder
          locked={false}
          loading={false}
        />
      </div>

      <style jsx>
        {`
          .plusIcon {
            height: 20px;
            margin-right: 0.75em;
          }
        `}
      </style>
    </BoxWithOptionalNumberedHeading>
  );
});
